<template>
  <div>
    <div style="position: relative; width: 1024px; display: inline-block;">

      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1024" height="327" viewBox="0 0 1024 327">
        <defs>
          <path id="prefix__a" d="M0 0.044L32.841 0.044 32.841 29.286 0 29.286z"/>
          <path id="prefix__c" d="M0 163.931L179.074 163.931 179.074 0 0 0z"/>
          <path id="prefix__e" d="M0 196.733L416.457 196.733 416.457 0 0 0z"/>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <g fill="#F0E8DD">
            <path d="M1010.006 87.055L796.723 49.442 649.979 80.468 259.405 144.803 0 115.428 172.034 267 1395.835 267 1697.661 174.741 1256.531 39.103z" transform="translate(-487) translate(0 60)"/>
            <path d="M1242.429 33.456L1242.429 118.531 1327.504 118.531 1327.504 33.456 1287.356 0zM1214.797 106.883c-11.087 0-20.074-8.988-20.074-20.074V46.661c0-11.086 8.987-20.073 20.074-20.073 11.087 0 20.073 8.987 20.073 20.073V86.81c0 11.086-8.986 20.074-20.073 20.074" transform="translate(-487) translate(0 60)"/>
            <path d="M487 83L1511 83 1511 245 487 245z" transform="translate(-487) translate(0 60) matrix(1 0 0 -1 0 328)"/>
          </g>

          <slot name="g" />
        </g>
      </svg>
      <slot/>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>
